import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite';
import './poster.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import {QRCodeSVG} from 'qrcode.react';
import html2canvas from "html2canvas";
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { errorCaptured } from '@commons/util';
import ajax from '@commons/api/ajax';
import CONFIG from '@commons/api/config';
import RootStore from '@stores';
import { useShareReplace } from '@commons/shareLink';

interface NameCardPosterProps {
    mgmCode: string,
    mgmShares: any,
    setShowNameCard: (status: boolean) => void,
    imgSrc:string
}
const NameCardPoster:React.FC<NameCardPosterProps> = observer((props)=> {
    const {mgmCode, mgmShares, setShowNameCard, imgSrc} = props;
    const [base64NameCardImage, setBase64NameCardImage] = useState("");
    const { formatString } = useShareReplace()
    const {i18n} = useTranslation();
    const language = i18n.language;

    const namecardRef = useRef(null);
    const { langTag } = RootStore.BasicInfoStore;

    const exportJpg = () => {
        let scale = window.innerWidth <= 640 ? 2 : 1;
        html2canvas(namecardRef.current, { allowTaint: false, useCORS: true, logging: true, scale }).then(function (canvas: any) {
          saveAs(canvas.toDataURL(), "NameCard.jpg");
        });
    };
    
    const imageToBase64 =  async (imageUrl: string) => {
      let res = await axios.get(`${imageUrl}?timestamp=11111`, {
          responseType: 'arraybuffer' // 以二进制流的形式获取图片
      })
      .then(response => {
          const buffer = response.data; // 获取图片的二进制数据
      
          // 将二进制数据转换成 Base64
          const base64Image = Buffer.from(buffer).toString('base64');
          console.log(base64Image); // Base64 图片数据
          return base64Image
      })
      .catch(error => {
          console.error('Error fetching image:', error);
      });
      console.log(res, 'w');
    }

    const getShareMessageData = () => {
      let msg = formatString(props.mgmShares.nameCardRedirect || '', [`${language === 'zh-HK' ? 'tc' : 'en'}`, props.mgmCode])
      return msg;
    }
    
    const saveAs = (uri:string, filename: string) => {
        let link = document.createElement("a");
        // for myhkbn
        if (window &&
          window.navigator &&
          window.navigator.userAgent &&
          (window.navigator.userAgent.indexOf("MyHKBNApp;Android") > -1 ||
            window.navigator.userAgent.indexOf("MyHKBNApp;iOS") > -1)) {
          // support myHKBN In app browser to share
          var dsBridge = require("dsbridge");
          var params = {
            "type": "operation",
            "function": "Image.saveFromUrl",
            "extraData": uri
          }
          dsBridge.call("nativeAsyncBridgeMessage", JSON.stringify(params), (callbackParam: any) => myHkbnCallback(callbackParam));
        } else {
          if (typeof link.download === "string") {
            link.href = uri;
            link.download = filename;
    
            //Firefox requires the link to be in the body
            document.body.appendChild(link);
    
            //simulate click
            link.click();
    
            //remove the link when done
            document.body.removeChild(link);
          } else {
            window.open(uri);
          }
        }
    };

    
    const myHkbnCallback = (callbackParam: any) => { }
    
    const closeOverlay = () => {
        setShowNameCard(false);
    }


    return (
        <div className={"main-wrapper"}>
            {
                Object.keys(mgmShares).length &&              
                <div className={"inner-wrapper"}>
                    <FontAwesomeIcon icon={faXmark} className={`button ${"btn-close"}`} onClick={() => closeOverlay()} />
                    <div className={"name-card-wrapper"} ref={namecardRef}>
                        {/* <img src={`${mgmShares.nameCardImage}?t=1111`}  alt='' /> */}
                        <img src={`${imgSrc}`}  alt='' />
                        <div className={"qr-code"}>
                            <QRCodeSVG value={`${getShareMessageData()}`} level={`H`} />
                        </div>
                        {/* <div className={"referral-url"}>{`https://r.hkbn.net/${props.referralCode}`}</div> */}
                        <div className={"referral-url"}>{`${getShareMessageData()}`}</div>
                        <div className={"referral-code"}>
                            {mgmCode}
                        </div>
                    </div>
                    <div className={`button ${"btn-download"}`} onClick={() => exportJpg()}>下载 </div>
                </div>
            }
        </div>
    )
})

export default NameCardPoster;